// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"threeDots_wrapper__S2xdM","dot":"threeDots_dot__CvTvH","dot_middel":"threeDots_dot_middel__RCP3y","dot2":"threeDots_dot2__XyPs5"};